<template>

    <div>

        <el-dialog title="加、减分配置" width="60%" :visible="addSubconfDialogVisible" @close="close" center>
            <el-form :model="addsubConfInfo" ref="form_conf_record" label-width="85px" class="demo-ruleForm"
                     :rules="rule_record">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="序号" prop="seq">
                            <el-input v-model="addsubConfInfo.seq" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="描述" prop="desc">
                            <el-input type="textarea" rows="3" v-model="addsubConfInfo.desc" maxlength="500"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="text-align: center">
                    <el-button center="true" type="primary" @click="save">确 定</el-button>
                    <el-button center @click="close">关 闭</el-button>
                </el-row>
            </el-form>
        </el-dialog>

    </div>

</template>

<script>
    import AssessmentServer from "../../../api/assessment";

    let that;

    export default {
        name: "addsubConfDialog.vue",

        props: ['addSubconfDialogVisible', 'addsubConfInfo'],

        data() {
            return {

                rule_record: {
                    desc: [
                        {
                            required: true,
                            trigger: 'blur',
                            message: '请输入描述',
                        }
                    ]

                },

            }
        },

        methods: {

            close() {
                that.$emit('update:addSubconfDialogVisible', false);
            },

            save() {
                that.$refs['form_conf_record'].validate((valid) => {
                    if (valid) {
                        if (that.addsubConfInfo.id == null) {
                            AssessmentServer.addsubConf.add(that.addsubConfInfo).then(res => {
                                if (res.data.code != 200) {
                                    that.$message.error(res.data.message);
                                } else {
                                    that.$message.success('加、减分项添加成功');
                                    that.addSubconfDialogVisible = false;
                                    that.$emit("afterSavedAddSubConfRecord", that.addsubConfInfo);
                                }
                            });
                        } else {
                            AssessmentServer.addsubConf.update(that.addsubConfInfo.id, that.addsubConfInfo).then(res => {
                                if (res.data.code != 200) {
                                    that.$message.error(res.data.message);
                                } else {
                                    that.$message.success('加、减分项更新成功');
                                    that.addSubconfDialogVisible = false;
                                    that.$emit("afterSavedAddSubConfRecord", that.addsubConfInfo);
                                }
                            });
                        }
                    }
                });
            },

        },

        computed: {},

        mounted() {
            that = this;
        }
    }
</script>

<style scoped>

</style>